export const API_ROOT = "/.netlify/functions/index";

export const AUTH_ROOT = `${API_ROOT}/auth`;
export const LOGIN = `${AUTH_ROOT}/login`;

export const PRODUCTS_ROOT = `${API_ROOT}/products`;
export const PRODUCT = (productName) => `${PRODUCTS_ROOT}/${productName}`;
